import React from 'react';
import { motion } from 'framer-motion';
import { Quote, Star } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const testimonials = [{
  quote: 'Am participat la cursurile de Theta Healing® susținute de Adrian Huniade cu deschidere totală, iar experiența a depășit orice așteptare. Trainerul a fost extrem de empatic și bine pregătit, iar atmosfera caldă m-a făcut să mă simt în siguranță. Ceea ce mi-a plăcut cel mai mult a fost caracterul practic — am aplicat tehnicile în timp real și am observat rezultate rapide: claritate mentală, liniște interioară și încredere în mine. Recomand cu toată inima oricui își dorește o transformare autentică și profundă.',
  name: 'Carmen Crișan',
  title: 'Cursantă',
  initial: 'C'
}, {
  quote: 'Înainte de aceste cursuri eram pierdută, fără direcție, fără claritate. Cursurile de Theta Healing® cu maestrul Adrian Huniade au fost exact acel punct de cotitură. Cu blândețe și răbdare, a creat un spațiu în care m-am simțit în siguranță să mă deschid și să lucrez profund cu mine. Pas cu pas m-am stabilizat emoțional, am înțeles tiparele și am învățat să le schimb. Transformările s-au reflectat rapid în realitate: o casă, o afacere și conexiuni autentice cu cei dragi.',
  name: 'Feli Iscru',
  title: 'Cursantă',
  initial: 'F'
}, {
  quote: 'L-am descoperit pe Adrian acum aproximativ 6 ani, într-o perioadă în care eram derutat și nu aveam un drum clar în viață. În urma cursurilor lui, am început treptat să văd mai limpede pașii pe care trebuie să îi urmez. Mi-a reaprins scânteia interioară și m-a ajutat să capăt claritate și direcție.',
  name: 'Coras Nicolae Dumitru',
  title: 'Săud, jud. Bihor',
  initial: 'C'
}, {
  quote: 'Am participat la cursurile lui Adrian cu dorința de a lucra mai profund cu mine însămi. Experiența a fost peste așteptările mele — am învățat tehnici practice de identificare și schimbare a convingerilor limitative. Instructorul a fost calm, empatic și foarte clar, iar schimbările s-au observat chiar în timpul cursului.',
  name: 'Emilia Popșor',
  title: 'Medic pediatru, Calgary, Canada',
  initial: 'E'
}];
export function TestimonialeWritten() {
  return <section className="py-20 lg:py-28 bg-[#4F2E7E] relative overflow-hidden" data-id="element-1932">
      {/* Decorative blobs */}
      <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-brand-gold/15 rounded-full blur-3xl translate-x-1/3 -translate-y-1/3 pointer-events-none" data-id="element-1933" />
      <div className="absolute bottom-0 left-0 w-[300px] h-[300px] bg-brand-gold/10 rounded-full blur-3xl -translate-x-1/3 translate-y-1/3 pointer-events-none" data-id="element-1934" />

      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-1935">
        <SectionHeading eyebrow="Mărturii Scrise" title="Povești pe care le citești cu inima" subtitle="Fiecare cuvânt e scris de cineva care a venit cu o întrebare și a plecat cu un răspuns trăit." light={true} data-id="element-1936" />

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8" data-id="element-1937">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: index % 2 * 0.1
        }} className="relative bg-white rounded-3xl p-7 lg:p-8 border border-brand-gold/15 shadow-sm hover:shadow-warm transition-shadow flex flex-col h-full" data-id="element-1938">
              <Quote className="absolute top-6 right-6 w-10 h-10 text-brand-gold/20" data-id="element-1939" />

              <div className="flex items-center gap-1 mb-4" data-id="element-1940">
                {Array.from({
              length: 5
            }).map((_, i) => <Star key={i} className="w-4 h-4 text-brand-gold fill-brand-gold" data-id="element-1941" />)}
              </div>

              <p className="font-subtitle italic text-brand-text leading-relaxed mb-6 flex-grow" data-id="element-1942">
                "{testimonial.quote}"
              </p>

              <div className="flex items-center gap-4 pt-5 border-t border-brand-gold/15 mt-auto" data-id="element-1943">
                <div className="w-12 h-12 rounded-full bg-brand-purple/10 flex items-center justify-center text-brand-purple font-heading font-bold text-xl shrink-0" data-id="element-1944">
                  {testimonial.initial}
                </div>
                <div className="min-w-0" data-id="element-1945">
                  <h4 className="font-heading font-bold text-brand-text truncate" data-id="element-1946">
                    {testimonial.name}
                  </h4>
                  <p className="text-sm text-brand-textSec truncate" data-id="element-1947">
                    {testimonial.title}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}